// transición suave de la imágen de fondo de la seccion contacto.
document.addEventListener('DOMContentLoaded', (e) => {
    let $img = document.querySelector('.img');
    $img.style.width = '100%';
});

let $themeButtons = document.querySelectorAll('.back__inicio');
    
$themeButtons.forEach((el) => {
    el.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('body').classList.add('out-animation');
        setTimeout(() => {
            location.href = '/'
        }, 1000);
    })
});

const d = document;

const $form = document.querySelector('.contact-form'),
      $inputs = document.querySelectorAll('.contact-form *[required]');

$inputs.forEach(input => {
    const $span = d.createElement('span');
    $span.id = input.name;
    $span.textContent = input.title;
    $span.classList.add('contact-form-error', 'none');
    input.insertAdjacentElement('afterend', $span)
});

d.addEventListener('keyup', (e) => {
    if(e.target.matches('.contact-form [required]')) {
        let $input = e.target,
            pattern = $input.pattern || $input.dataset.pattern;
            console.log($input, pattern);

        if(pattern && $input.value !== '') {
            let regex = new RegExp(pattern);
            return !regex.exec($input.value)
                ? d.getElementById($input.name).classList.add('is-active')
                : d.getElementById($input.name).classList.remove('is-active');
        }

        if(!pattern) {
            return $input.value === ''
                ? d.getElementById($input.name).classList.add('is-active')
                : d.getElementById($input.name).classList.remove('is-active');
        }
    }
});

let $formElements = d.querySelectorAll('.form-element');
let $imgContainer = d.querySelector('.img-container');

$formElements.forEach(el => {
    el.addEventListener('focus', (e) => {
        console.log($imgContainer);
        $imgContainer.style.filter = 'blur(5px)';
    });
});

$form.addEventListener('submit', (e) => {
    $formElements.forEach(el => {
        el.value = ''
        $imgContainer.style.filter = 'blur(0px)';
    });
});